module.exports = __webpack_public_path__ + "application/directives/svg-image/xml-svg/xml-svg.template.html";